
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.719 20.359c-.562.094-1.141.141-1.719.141-5.797 0-10.5-4.703-10.5-10.5 0-1.984.578-3.922 1.625-5.578A9.952 9.952 0 002 14c0 5.516 4.484 10 10 10 3.016 0 5.844-1.375 7.719-3.641zm3.172-1.328A12.035 12.035 0 0112 26C5.391 26 0 20.609 0 14A11.95 11.95 0 0111.547 2.016a.976.976 0 01.953.609c.172.391.063.844-.234 1.125A8.372 8.372 0 009.5 10c0 4.688 3.813 8.5 8.5 8.5a8.352 8.352 0 003.563-.797 1 1 0 011.328 1.328z"}})])
          )
        }
      }
    